import { WrestlerDetailViewData } from '../../screens/roster/RosterScreen'
import { ReactElement } from 'react'
import styles from './MobileWrestlerDetailView.module.scss'
import { MobileBodyLarge, MobileHeadlineLarge } from '../../Typography'
import { URLS } from '../../content/urls'

type Props = {
  data: WrestlerDetailViewData
}

export const MobileWrestlerDetailView = ({ data }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.imageColumn}>
        <div onClick={data.onBackClick}>
          <MobileBodyLarge>Zurück zum Roster</MobileBodyLarge>
        </div>
        <div className={styles.imageWrapper}>
          <img
            src={
              data.wrestler.profilbild !== '' ? data.wrestler.profilbild : URLS.vakantWrestlerImage
            }
            alt={`Foto von ${data.wrestler.name}`}
          />
        </div>
      </div>
      <div className={styles.infoColumn}>
        <div className={styles.wrestlerDetailColumn}>
          <MobileHeadlineLarge>{data.wrestler.name}</MobileHeadlineLarge>
          <div className={styles.metaDataColumn}>
            <div className={styles.metaDataRow}>
              <MobileBodyLarge fontWeight={700}>Herkunft</MobileBodyLarge>
              <MobileBodyLarge>{data.wrestler.herkunft}</MobileBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <MobileBodyLarge fontWeight={700}>Größe</MobileBodyLarge>
              <MobileBodyLarge>{data.wrestler.groesse}</MobileBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <MobileBodyLarge fontWeight={700}>Gewicht</MobileBodyLarge>
              <MobileBodyLarge>{data.wrestler.gewicht}</MobileBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <MobileBodyLarge fontWeight={700}>Finisher</MobileBodyLarge>
              <div className={styles.movesList}>
                {data.wrestler.finisher.map((finisher, index) => (
                  <MobileBodyLarge key={index}>{finisher}</MobileBodyLarge>
                ))}
              </div>
            </div>
            <div className={styles.metaDataRow}>
              <MobileBodyLarge fontWeight={700}>Signature</MobileBodyLarge>
              <div className={styles.movesList}>
                {data.wrestler.signature.map((signature, index) => (
                  <MobileBodyLarge key={index}>{signature}</MobileBodyLarge>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.biography}>
            <MobileBodyLarge dangerouslySetInnerHTML={{ __html: data.wrestler.biografie }} />
          </div>
        </div>
      </div>
    </div>
  )
}
